export { default } from './part-replacement-process';
